import { Node, NodeProps } from "@xyflow/react"
import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { TriangleAlert } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useWorkflowEnabled } from "../hooks/useWorkflowEnabled"

export function WorkflowBannerNode({ data }: NodeProps<Node>) {
  const { t } = useTranslation()
  const { workflowId = "", width } = data as { workflowId?: string; width?: number }
  const isEnabled = useWorkflowEnabled(workflowId)

  if (isEnabled) return null

  return (
    <Tooltip>
      <TooltipTrigger
        className="nodrag nopan flex w-full items-center justify-center gap-1.5 rounded-md border border-warning/40 bg-warning/10 px-2 py-1 text-warning"
        style={{ width }}
      >
        <TriangleAlert className="size-3.5 shrink-0" />
        <span className="text-xs font-medium">{t("settings.workflows.disabled.title")}</span>
      </TooltipTrigger>
      <TooltipContent>{t("settings.workflows.disabled.tooltip")}</TooltipContent>
    </Tooltip>
  )
}
